import { combineReducers } from "redux";
import { reducers as CommonDashboard } from "./CommonDashboard";
import { reducers as nav } from "./Navigation";
import {
  reducers as RequestReason,
  reducers as AddRequestReason,
  reducers as GetBranchDetails,
  reducers as GetItemDetails,
  reducers as GetVehicleDetails,
  reducers as setVehicleTypeId,
  reducers as MyOrder,
} from "./MyOrder";
import { reducers as UserProfile } from "./UserProfile";
import { reducers as PendingOrder } from "./PendingOrder";
import { reducers as ManagedEquipment } from "./ManagedEquipment";
import { reducers as CustomerMyOrder } from "./CustomerMyOrder";
import { reducers as NonStandardEquipment } from "./NonStandardEquipment";
import { reducers as PurchaseOrder } from "./PurchaseOrder";
import { reducers as AssetTransfer } from "./AssetTransfer";
import { reducers as AppRole } from "./AppRole";
import { reducers as UserManagement } from './UserManagement'
import AssetManagement from '../Store/AssetManagement/AssetType/AssetTypeReducer'
import AssetSubTypeManagement from '../Store/AssetManagement/AssetSubType/AssetSubTypeReducer'
import CostCenter from '../Store/AssetManagement/CostCenter/CostCenterReducer'
import { reducers as RequisitionReducer } from '../Store/Component/Requisition/RequisitionReducer'
import VehicleCapacity from '../Store/AssetManagement/VehicleCapacity/VehicleCapacityReducer'
import NoOfDoors from '../Store/AssetManagement/NoOfDoors/NoOfDoorsReducer'
import AssetNumber from '../Store/AssetManagement/AssetNumber/AssetNumberReducer'
import UpfitOptionReducer from '../Store/AssetManagement/UpfitOption/UpfitOptionReducer'
import DriveTrainReducer from '../Store/AssetManagement/DriveTrain/DriveTrainReducer'
import ReasonType from '../Store/AssetManagement/ReasonType/ReasonTypeReducer'
import Condition from '../Store/AssetManagement/Condition/ConditionReducer'
import Status from '../Store/AssetManagement/Status/StatusReducer'
import RequisitionDropDownReducer from '../Store/AssetManagement/RequisitionDropDown/RequisitionDropDownReducer'
import { reducers as UploadAttachmentsReducer } from '../Store/AssetManagement/UploadAttachments/UploadAttachmentsReducer'
import Equipment from '../Store/AssetManagement/Equipment/EquipmentReducer'
import ManagedEquipmentDropDownReducer from '../Store/AssetManagement/ManagedEquipmentDropDown/ManagedEquipmentDropDownReducer'
import OrderReducer from '../Store/OrderManagement/Order/OrderReducer'
import ApprovalReducer from '../Store/OrderManagement/Approval/ApprovalReducer'
import OrderApprovalReducer from '../Store/Component/OrderApproval/OrderApprovalReducer'
import { reducers as VendorDetailsReducer } from '../Store/Organization/VendorDetails/VendorDetailsReducer'
import AlertAndNotificationsReducer from '../Store/AlertNotification/AlertNotificationReducer'
import { reducers as DriverTitleReducer } from '../Store/AssetManagement/DriverTitle/DriverTitleReducer'
import CatalogItemReducer from '../Store/AssetManagement/CatalogItem/CatalogItemReducer'
import PriceInfoReducer from "Store/AssetManagement/PriceInfo/PriceInfoReducer";
import { reducers as TransferGridReducer } from '../Store/Transfer/TransferGrid/TransferGridReducer'
import { reducers as GlobalLoaderReducer } from '../Store/Component/GlobalLoader/GlobalLoaderReducer'
import { reducers as TransferReducer } from '../Store/Component/Transfer/TransferReducer'
import { reducers as DivisionsReducer } from '../Store/Organization/Divisions/DivisionsReducer'
import { reducers as CostCentersReducer } from '../Store/Organization/CostCenters/CostCentersReducer'
import { reducers as AssignmentTransferTypesReducer } from '../Store/OrderManagement/AssignmentTransferTypes/AssignmentTransferTypesReducer'
import TransferApprovalReducer from '../Store/Transfer/TransferApproval/TransferApprovalReducer'
import TransferOrderReducer from '../Store/Transfer/Transfer/TransferOrderByIdReducer'
import DispositionChoiceReducer from '../Store/OrderManagement/DispositionChoice/DispositionChoiceReducer'
import ReasonCodeReducer from '../Store/OrderManagement/ReasonCode/ReasonCodeReducer'
import { reducers as StatesReducer } from '../Store/Organization/States/StatesReducer'
import FleetProcessingReducer from '../Store/OrderManagement/FleetProcessing/FleetProcessingReducer'
import { reducers as CitiesReducer } from '../Store/Organization/Cities/CitiesReducer'
import { reducers as titleReducer } from '../Store/Organization/Title/TitleReducer'
import { reducers as OrderGridDropdownsReducer } from '../Store/OrderManagement/OrderGridDropdowns/OrderGridDropdownsReducer'
import { reducers as BulkOrderDashboardReducer } from '../Store/OrderManagement/BulkOrderDashboard/BulkOrderDashboardReducer'
import { reducers as BulkOrderReducer } from '../Store/Component/BulkOrder/BulkOrderReducer'
import { reducers as PurchaseBulkOrderReducer } from '../Store/Component/PurchaseBulkOrder/PurchaseBulkOrderReducer'
import { reducers as CatalogManagementReducer } from '../Store/Component/CatalogManagement/CatalogManagementReducer'
import DivisionalApproverRequisitionTypeReducer from '../Store/OrderManagement/DivisionalApproverRequisitionType/DivisionalApproverRequisitionTypeReducer'
import { reducers as PrimaryApproverReducer } from '../Store/Identity/PrimaryApprover/PrimaryApproverReducer'
import { reducers as SecondaryApproverReducer } from '../Store/Identity/SecondaryApprover/SecondaryApproverReducer'
import { reducers as RegionByEmailReducer } from '../Store/Identity/Region/RegionReducer'
import GridFiltersReducer from '../Store/Component/GridDataFilters/GridDataFiltersReducer'
import { reducers as EmployeeInfoReducer } from '../Store/OrderManagement/EmployeeInfo/EmployeeInfoReducer'
import AssetInventoryNavReducer from '../Store/AssetInventory/Navigation/NavigationReducer'
import AssetInventoryQuestionOptionReducer from '../Store/AssetInventory/QuestionOption/QuestionOptionReducer'
import AssessmentReducer from '../Store/AssetInventory/Assessments/AssessmentReducer'
import UsersReducer from '../Store/AssetInventory/Users/UsersReducer'
import UserProfileReducer from '../Store/Identity/UserProfiles/UserProfileReducer'
import fleetAdminTaskReducer from '../Store/Component/FleetManagement/FleetManagementReducer'
import GLAccountCodesReducer from '../Store/FleetManagement/GLAccountCodes/GLAccountCodesReducer'
import adminTaskReducer from '../Store/FleetManagement/FleetAdminTask/AdminTaskReducer'
import AssetInventoryAuditDatesReducer from '../Store/AssetInventory/AuditDates/AuditDatesReducer'
import FleetItemCancelReducer from '../Store/FleetManagement/FleetItemCancel/FleetItemCancelReducer'
import ReceivingBranchReducer from '../Store/FleetManagement/FleetTransferReceivingBranch/FleetTransferReceivingBranchReducer'
import FleetAssetCommentsReducer from '../Store/FleetManagement/FleetAssetCommentsSave/FleetAssetCommentsSaveReducer'
import FleetDispositionLocationReducer from '../Store/FleetManagement/FleetDispositionLocationsave/FleetDispositionLocationsaveReducer'
import FleetDispositionSaveReducer from '../Store/FleetManagement/FleetDispositionSave/FleetDispositionSaveReducer'
import FleetAssetChangeLogReducer from '../Store/FleetManagement/FleetAssetChangeLog/FleetAssetChangeLogReducer'
import UserReducer from '../Store/Identity/User/UserReducer'
import ErrorLogReducer from '../Store/Identity/ErrorLog/ErrorLogReducer'
import ComponentErrorLogReducer from '../client/Components/Store/Identity/ComponentErrorLog/ComponentErrorLogReducer'
import CommonErrorHandlerReducer from '../Store/CommonErrorHandler/CommonErrorHandlerReducer'
import FleetDispositionPaymentReducer from '../Store/FleetManagement/FleetDispositionPaymentSave/FleetDispositionPaymentSaveReducer'
import {reducers as AddressDropDownReducer} from '../Store/Organization/AutoCompleteAddressSearch/AddressSearchReducer'
import {reducers as AddressDetailReducer} from '../Store/Organization/AutoCompleteAddressDetails/AddressDetailsReducer'
import FuelTypeReducer from '../Store/AssetManagement/FuelType/FuelTypeReducer'
import BulkOrderSaveReducer from '../Store/OrderManagement/BulkOrderSave/BulkOrderSaveReducer'
import BulkOrdeByIdReducer from '../Store/OrderManagement/BulkOrderById/BulkOrderByIdReducer'
import mergerAndAquisitionReducer from "Store/AssetInventory/MandAScan/MandAScanReducer";
import DispositionPenaltyFeeReducer from '../Store/OrderManagement/DispositionPenaltyFee/DispositionPenaltyFeeReducer';
import {reducers as ReportListReducer} from '../Store/Report/ReportList/ReportListReducer'
import {reducers as AcquisitionCodeMaintenanceReducer} from '../Store/Report/AcquisitionCodeMaintenance/AcquisitionCodeMaintenanceReducer'
import DispositionPenaltyFlagReducer from '../Store/OrderManagement/DispositionPenalityFlag/DispositionPenalityFlagReducer';
import NewAcquisitionCodeReducers from '../Store/OrderManagement/AcquisitionCode/AcquisitionCodeReducer'
import ApprovalHistoryReducer from '../Store/Component/ApprovalHistoryTab/ApprovalHistoryReducer'
import AssetItemStatusHeaderDetailReducers from '../Store/FleetManagement/AssetItemStatusHeaderDetails/AssetItemStatusHeaderDetailsReducer';
import AssetItemStatusPurchaseDetailReducer from '../Store/FleetManagement/AssetItemStatusPurchaseDetail/AssetItemStatusPurchaseDetailReducer';
import AssetItemStatusVendorDetailReducer from '../Store/FleetManagement/AssetItemStatusVendorDetail/AssetItemStatusVendorDetailReducer';
import AssetItemStatusPurchaseOrderReducer from '../Store/FleetManagement/AssetItemStatusPurchaseOrder/AssetItemStatusPurchaseOrderReducer';
import AssetItemStatusTaskDetailsReducer from '../Store/FleetManagement/AssetItemStatusTaskDetails/AssetItemStatusTaskDetailsReducer';
import AssetFleetProcessingReducer from '../Store/FleetManagement/AssetFleetProcessing/AssetFleetProcessingReducer';
import AssetFleetLinkAttachmentReducer from '../Store/FleetManagement/AssetFleetProcessingLinkAttachment/AssetFleetProcessingLinkAttachmentReducer';
import CatalogDropDownUpdateReducers from '../Store/AssetManagement/CatalogItemDropDownUpdate/CatalogItemDropDownUpdateReducer';
import ResetAssetInventoryReducers from '../Store/AssetInventory/AssetInventoryReset/AssetInventoryResetReducer';
import UserFilterBySearchTextReducers from '../Store/Identity/UserBySearchText/UserBySearchTextReducer';
import {reducers as MarketByRegionReducers} from '../Store/Organization/MarketByRegion/MarketByRegionReducer';
import AuditReadinessWorkBookReducers from '../Store/AssetManagement/AuditReadinessworkBook/AuditReadinessworkBookReducer';
import CostCenterByMarketReducers from '../Store/Organization/CostCenterByMarket/CostCenterByMarketReducer';
import PoVendorEmailReducers from '../Store/AlertNotification/PoVendorEmail/PoVendorEmailReducers';
import FleetRefreshPurchaseOrderReducer from '../Store/FleetManagement/FleetrefreshPurchaseOrder/FleetRefreshPurchaseOrderReducer';
import POVendorEmailHistoryReducers from '../Store/FleetManagement/FleetPOVendorEmailHistory/FleetPOVendorEmailHistoryReducer';
import FleetPurchaseOrderHistoryReducers from "Store/FleetManagement/FleetPurchaseOrderHistory/FleetPurchaseOrderHistoryReducer";
import AssetAuditResetHistoryLogReducer from "../Store/AssetInventory/AssetAuditResetHistoryLog/AssetAuditResetHistoryLogReducer";
import BranchAdminAccessReducer from '../Store/AssetInventory/BranchAdminAccess/BranchAdminAccessReducer';
import FleetItemReturnReducer from '../Store/FleetManagement/FleetItemReturnToRequestor/FleetItemReturnToRequestorReducer';
import JobTitleReducer from '../Store/AssetManagement/JobTitle/JobTitleReducer';
import SuperRegionReducers from '../Store/Organization/SuperRegion/SuperRegionReducer'
import ApprovalHierarchyReducers from '../Store/OrderManagement/ApprovalHierarhy/ApprovalHierarhyReducer'
import ApprovalListAssignmentReducer from '../Store/OrderManagement/ApprovalListAssignment/ApprovalListAssignmentReducer'
import {reducers as RegionDropDownReducer} from '../Store/Organization/Region/RegionReducer'
import MarketDropDownReducer from '../Store/Organization/Market/MarketReducer'
import ApprovalHistoryReportReducer from '../Store/OrderManagement/ApprovalHistoryReport/ApprovalHistoryReportReducer'
import ComplianceReportReducer from '../Store/OrderManagement/ComplainceReport/ComplainceReportReducer'
import BranchDropDownReducer from '../Store/Organization/Branch/BranchReducer'
import OutOfOfficeReducer from '../Store/OrderManagement/OutOfOffice/OutOfOfficeReducer'
import UserDefaultLocationReducer from '../Store/Identity/DefaultLocation/DefaultLocationReducer';
import ActiveAssetDashboardReducer from '../Store/AssetManagement/ActiveAssetDashboard/ActiveAssetDashboardReducer';
import ActiveAssetDropDownReducer from '../Store/AssetManagement/ActiveAssetDropDown/ActiveAssetDropDownReducer';
import ActiveAssetReportReducer from '../Store/AssetManagement/ActiveAssetReport/ActiveAssetReportReducer';
import AssetEoneDetailsReducer from '../Store/AssetManagement/AssetEoneDetails/AssetEoneDetailsReducer';
import BillOfSaleReducer from '../Store/OrderManagement/BillOfSale/BillOfSaleReducer';
import BarcodeReportReducer from '../Store/Report/BarcodeReport/BarcodeReportReducer';

const rootReducer = combineReducers({
  RequisitionDropDownReducer,
  CommonDashboard,
  nav,
  RequestReason,
  AddRequestReason,
  GetBranchDetails,
  GetItemDetails,
  GetVehicleDetails,
  MyOrder,
  UserProfile,
  setVehicleTypeId,
  PendingOrder,
  CustomerMyOrder,
  ManagedEquipment,
  NonStandardEquipment,
  PurchaseOrder,
  AssetTransfer,
  AppRole,
  UserManagement,
  AssetManagement,
  AssetSubTypeManagement,
  CostCenter,
  RequisitionReducer,
  VehicleCapacity,
  NoOfDoors,
  AssetNumber,
  UpfitOptionReducer,
  DriveTrainReducer,
  ReasonType,
  Condition,
  Status,
  UploadAttachmentsReducer,
  Equipment,
  ManagedEquipmentDropDownReducer,
  OrderReducer,
  ApprovalReducer,
  OrderApprovalReducer,
  CatalogItemReducer,
  VendorDetailsReducer,
  DriverTitleReducer,
  AlertAndNotificationsReducer,
  TransferReducer,
  DivisionsReducer,
  CostCentersReducer,
  AssignmentTransferTypesReducer,
  TransferApprovalReducer,
  TransferOrderReducer,
  PriceInfoReducer,
  TransferGridReducer,
  GlobalLoaderReducer,
  DispositionChoiceReducer,
  ReasonCodeReducer,
  StatesReducer,
  CitiesReducer,
  GridFiltersReducer,
  EmployeeInfoReducer,
  FleetProcessingReducer,
  OrderGridDropdownsReducer,
  BulkOrderDashboardReducer,
  BulkOrderReducer,
  PurchaseBulkOrderReducer,
  CatalogManagementReducer,
  AssetInventoryQuestionOptionReducer,
  AssessmentReducer,
  AssetInventoryNavReducer,
  titleReducer,
  DivisionalApproverRequisitionTypeReducer,
  PrimaryApproverReducer,
  SecondaryApproverReducer,
  RegionByEmailReducer,
  UsersReducer,
  UserProfileReducer,
  fleetAdminTaskReducer,
  GLAccountCodesReducer,
  adminTaskReducer,
  AssetInventoryAuditDatesReducer,
  FleetItemCancelReducer,
  ReceivingBranchReducer,
  FleetAssetCommentsReducer,
  FleetDispositionLocationReducer,
  FleetDispositionSaveReducer,
  FleetAssetChangeLogReducer,
  ErrorLogReducer,
  ComponentErrorLogReducer,
  CommonErrorHandlerReducer,
  UserReducer,
  FleetDispositionPaymentReducer,
  AddressDropDownReducer,
  AddressDetailReducer,
  FuelTypeReducer,
  BulkOrderSaveReducer,
  BulkOrdeByIdReducer,
  mergerAndAquisitionReducer,
  DispositionPenaltyFeeReducer,
  ReportListReducer,
  AcquisitionCodeMaintenanceReducer,
  DispositionPenaltyFlagReducer,
  NewAcquisitionCodeReducers,
  ApprovalHistoryReducer,
  AssetItemStatusHeaderDetailReducers,
  AssetItemStatusPurchaseDetailReducer,
  AssetItemStatusVendorDetailReducer,
  AssetItemStatusPurchaseOrderReducer,
  AssetItemStatusTaskDetailsReducer,
  AssetFleetProcessingReducer,
  AssetFleetLinkAttachmentReducer,
  CatalogDropDownUpdateReducers,
  ResetAssetInventoryReducers,
  UserFilterBySearchTextReducers,
  MarketByRegionReducers,
  AuditReadinessWorkBookReducers,
  CostCenterByMarketReducers,
  PoVendorEmailReducers,
  FleetRefreshPurchaseOrderReducer,
  POVendorEmailHistoryReducers,
  FleetPurchaseOrderHistoryReducers,
  AssetAuditResetHistoryLogReducer,
  BranchAdminAccessReducer,
  FleetItemReturnReducer,
  JobTitleReducer,
  SuperRegionReducers,
  ApprovalHierarchyReducers,
  ApprovalListAssignmentReducer,
  RegionDropDownReducer,
  MarketDropDownReducer,
  ApprovalHistoryReportReducer,
  ComplianceReportReducer,
  BranchDropDownReducer,
  OutOfOfficeReducer,
  UserDefaultLocationReducer,
  ActiveAssetDashboardReducer,
  ActiveAssetDropDownReducer,
  AssetEoneDetailsReducer,
  ActiveAssetReportReducer,
  BillOfSaleReducer,
  BarcodeReportReducer,
});

export default rootReducer;
